import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { saveFlightBooking } from "../services/services";
import LayoverImg1 from "./assets/img/LayoverImg-1.png";
import airlineImg from "./assets/img/airlineImg.png";
import bookingDtlImg from './assets/img/bookingDtlImg.jpg';
import PlaneIco from './assets/img/PlaneIco.png';
import TwoTickets from './assets/img/TwoTickets.png';
import Travelator from './assets/img/Travelator.png';
import Traveler from './assets/img/Traveler.png';
import Suitcase from './assets/img/Suitcase.png';
import BarcodeImg1 from './assets/img/BarcodeImg-1.png';
import BarcodeImg2 from './assets/img/BarcodeImg-2.png';

const FlightReservationTwo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const bookingData = location.state?.bookingData;
    console.log("Booking Data:", bookingData);
    const calculateDuration = (departure, arrival) => {
        const dep = new Date(departure);
        const arr = new Date(arrival);
        const diff = arr - dep;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return `${hours}h ${minutes}m`;
    };
    const formatDateWithWeekday = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
          weekday: 'short', 
          day: 'numeric', 
          month: 'short', 
          year: 'numeric' 
        });
      };
      const getCityByIata = (iataCode) => {
        return iataCode; // Return city name if available
    };
    const calculateLayoverTime = (arrival, nextDeparture) => {
        const arrivalDate = new Date(arrival);
        const departureDate = new Date(nextDeparture);
        const diffMs = departureDate - arrivalDate;
        const diffMins = Math.floor(diffMs / 60000);
        const hours = Math.floor(diffMins / 60);
        const minutes = diffMins % 60;
        return `${hours}h ${minutes}m`;
    };


  const directions = bookingData.FlightInfo?.Directions || [];
const isRoundTrip = bookingData.SearchInfo?.journeyType === "2";
const departureSegments = directions[0]?.[0]?.Segments || [];
  console.log("Is Round Trip:", isRoundTrip);
  const returnSegments = isRoundTrip ? directions[1]?.[0]?.Segments || [] : [];
  const segments = isRoundTrip ? [...departureSegments, ...returnSegments] : departureSegments;
// console.log("Directions:", directions);
// console.log("Departure:", directions[0]);
// console.log("Return:", directions[1]);

   
    if (!bookingData) {
        return <p>Loading booking details...</p>;
    }

    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="confirmedConWrap">
                    <div className="container">
                        <div className="row brdBtm align-items-center">
                            <div className="col-sm-6">
                                <div className="icoWrap">
                                    <div className="innerWrap">
                                        <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.5315 31.3354C15.1811 31.3343 14.8347 31.2611 14.5137 31.1204C14.1928 30.9797 13.9042 30.7745 13.6659 30.5176L1.24594 17.3054C0.781661 16.8106 0.53295 16.1517 0.554517 15.4735C0.576084 14.7954 0.866162 14.1535 1.36094 13.6893C1.85571 13.225 2.51466 12.9763 3.19281 12.9979C3.87096 13.0194 4.51277 13.3095 4.97705 13.8043L15.5059 25.0232L36.9982 1.51205C37.2163 1.24045 37.4876 1.01631 37.7955 0.853389C38.1034 0.69047 38.4413 0.592212 38.7886 0.564652C39.1358 0.537092 39.485 0.580812 39.8147 0.693125C40.1445 0.805438 40.4478 0.983974 40.706 1.21777C40.9642 1.45156 41.1719 1.73567 41.3163 2.05266C41.4607 2.36964 41.5388 2.71281 41.5458 3.06107C41.5528 3.40933 41.4885 3.75535 41.3568 4.07786C41.2252 4.40036 41.029 4.69256 40.7804 4.93649L17.4226 30.4921C17.1866 30.7536 16.899 30.9636 16.578 31.1087C16.2569 31.2538 15.9093 31.331 15.557 31.3354H15.5315Z" fill="black"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="topDataWrap">
                                    <h2>Congratulation!</h2>
                                    <p>You have Booked your flight succesfully.</p>
                                    {/* <p><strong>Booking Code Ref:</strong> {bookingData.BookingCodeRef}</p> */}
                                    <p><strong>Booking Ref Number:</strong> {bookingData.BookingRefNumber}</p>
                                    <p><strong>Booking Status:</strong> {bookingData.BookingStatus}</p>
                                    <p><strong>Booking Transaction Ref:</strong> {bookingData.BookingTransactionRef}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-sm-6">
                                <div className="btmDataWrap">
                                    <h4>Confirmation Details have been sent to</h4>
                                    <ul>
                                        <li>
                                            <p>SMS: <span>{bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.PhoneCountryCode}  {bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.Phone}</span></p>
                                        </li>
                                        <li>
                                            <p>Email ID: <span>{bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.Email}</span></p>
                                        </li>
                                    </ul>
                                    {/* <div className="codResendWrap">
                                        <button className="btn">Resend</button>
                                        <p>00:00</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="digitalTicketWrap">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-11">
                                <div className="titleWrap">
                                    <h2>Digital Ticket</h2>
                                </div>
                            </div>
                        </div>
                        
                        {directions[0].map((direction, dirIndex) => (
                            <div key={dirIndex} className="row justify-content-center">
                                <div className="col-sm-12 col-lg-11">
                                    <div className="ticketBox">
                                        <div className="leftWraps">
                                            <div className="topTTl">
                                                <h2>{dirIndex === 0 ? "Departure" : "Return"} Summary</h2>
                                            </div>

                                            {direction.Segments?.map((segment, segIndex) => (
                                                <div key={`seg-${segIndex}`} className="flightReservBgBlue">
                                                    <div className="topTtlWrap">
                                                        <div className="title">
                                                            <div className="icoWrap"><img src={airlineImg} className="img-fluid" alt="" /></div>
                                                            <h2>
                                                                {segment.Airline} - Flight {segment.FlightNumber}
                                                            </h2>
                                                        </div>
                                                        <h6 className="note">
                                                            {segment.Refundable ? "Refundable" : "Non-refundable"}
                                                        </h6>
                                                        <p className="classTxt">
                                                            Travel Class: <span>{segment.ServiceClass}</span>
                                                        </p>
                                                    </div>

                                                    <div className="trvelTicWrap">
                                                        <div className="leftWrap">
                                                            <ul>
                                                                <li>
                                                                    <div className="items mainItem">
                                                                        <div className="leftData">
                                                                            <h3>{segment.Origin}</h3>
                                                                            <h5>{segment.Departure?.split(" ")[1].slice(0, 5)}</h5>
                                                                        </div>
                                                                        <div className="rightData">
                                                                            <p>{formatDateWithWeekday(segment.Departure)}</p>
                                                                            <p>{getCityByIata(segment.Origin)}</p>
                                                                            <p>
                                                                                {segment.Details?.[0]?.OriginTerminal 
                                                                                    ? `Terminal: ${segment.Details[0].OriginTerminal}`
                                                                                    : "Terminal not specified"}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </li>

                                                                <li>
                                                                    <div className="items">
                                                                        <h4>{calculateDuration(segment.Departure, segment.Arrival)}</h4>
                                                                        <div className="planeIcoWrap">
                                                                            <img src={PlaneIco} className="img-fluid" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </li>

                                                                <li>
                                                                    <div className="items mainItem">
                                                                        <div className="leftData">
                                                                            <h3>{segment.Destination}</h3>
                                                                            <h5>{segment.Arrival?.split(" ")[1].slice(0, 5)}</h5>
                                                                        </div>
                                                                        <div className="rightData">
                                                                            <p>{formatDateWithWeekday(segment.Arrival)}</p>
                                                                            <p>{getCityByIata(segment.Destination)}</p>
                                                                            <p>
                                                                                {segment.Details?.[0]?.DestinationTerminal 
                                                                                    ? `Terminal: ${segment.Details[0].DestinationTerminal}`
                                                                                    : "Terminal not specified"}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className="rightWrap">
                                                            <ul>
                                                                <li>
                                                                    <p>Baggage</p>
                                                                    {segment.Baggage?.map((bag, i) => (
                                                                        <h3 key={i}>
                                                                            {bag.PassengerTypeCode}: {bag.Amount} {bag.Units}
                                                                        </h3>
                                                                    ))}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    {/* Layover Information */}
                                                    {segIndex < direction.Segments.length - 1 && (
                                                        <div className="ticketinfoWrap layover-info">
                                                            <ul>
                                                                <li>
                                                                    <img 
                                                                        src={LayoverImg1} 
                                                                        alt="Layover" 
                                                                        className="img-fluid" 
                                                                    />
                                                                    <p>
                                                                        Layover at {getCityByIata(segment.Destination)} ({segment.Destination}) - 
                                                                        Duration: {calculateLayoverTime(
                                                                            segment.Arrival, 
                                                                            direction.Segments[segIndex + 1].Departure
                                                                        )}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}

                                            <div className="ticketinfoWrap">
                                                <ul>
                                                    <li>
                                                        <img src={TwoTickets} alt="" className="img-fluid"/>
                                                        <p>Separate tickets booked together for cheaper price</p>
                                                    </li>
                                                    <li>
                                                        <img src={Travelator} alt="" className="img-fluid"/>
                                                        <p>Change of Terminal</p>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="btmNote">
                                                <img src={Traveler} className="img-fluid" alt="" />
                                                <p>Sorry, extra check-in baggage allowance details are not available currently from airline.</p>
                                            </div>
                                        </div>

                                        <div className="rightWraps">
                                            <div className="title">
                                                <h2>Bar Code</h2>
                                            </div>
                                            <div className="qrCode">
                                                <img src={BarcodeImg1} className="img-fluid" alt="" />
                                            </div>
                                            <div className="barCode">
                                                <img src={BarcodeImg2} className="img-fluid" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        {isRoundTrip  && directions[1].map((direction, dirIndex) => (
                            <div key={dirIndex} className="row justify-content-center">
                                <div className="col-sm-12 col-lg-11">
                                    <div className="ticketBox">
                                        <div className="leftWraps">
                                            <div className="topTTl">
                                                <h2>{dirIndex === 1 ? "Departure" : "Return"} Summary</h2>
                                            </div>

                                            {direction.Segments?.map((segment, segIndex) => (
                                                <div key={`seg-${segIndex}`} className="flightReservBgBlue">
                                                    <div className="topTtlWrap">
                                                        <div className="title">
                                                            <div className="icoWrap"><img src={airlineImg} className="img-fluid" alt="" /></div>
                                                            <h2>
                                                                {segment.Airline} - Flight {segment.FlightNumber}
                                                            </h2>
                                                        </div>
                                                        <h6 className="note">
                                                            {segment.Refundable ? "Refundable" : "Non-refundable"}
                                                        </h6>
                                                        <p className="classTxt">
                                                            Travel Class: <span>{segment.ServiceClass}</span>
                                                        </p>
                                                    </div>

                                                    <div className="trvelTicWrap">
                                                        <div className="leftWrap">
                                                            <ul>
                                                                <li>
                                                                    <div className="items mainItem">
                                                                        <div className="leftData">
                                                                            <h3>{segment.Origin}</h3>
                                                                            <h5>{segment.Departure?.split(" ")[1].slice(0, 5)}</h5>
                                                                        </div>
                                                                        <div className="rightData">
                                                                            <p>{formatDateWithWeekday(segment.Departure)}</p>
                                                                            <p>{getCityByIata(segment.Origin)}</p>
                                                                            <p>
                                                                                {segment.Details?.[1]?.OriginTerminal 
                                                                                    ? `Terminal: ${segment.Details[0].OriginTerminal}`
                                                                                    : "Terminal not specified"}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </li>

                                                                <li>
                                                                    <div className="items">
                                                                        <h4>{calculateDuration(segment.Departure, segment.Arrival)}</h4>
                                                                        <div className="planeIcoWrap">
                                                                            <img src={PlaneIco} className="img-fluid" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </li>

                                                                <li>
                                                                    <div className="items mainItem">
                                                                        <div className="leftData">
                                                                            <h3>{segment.Destination}</h3>
                                                                            <h5>{segment.Arrival?.split(" ")[1].slice(0, 5)}</h5>
                                                                        </div>
                                                                        <div className="rightData">
                                                                            <p>{formatDateWithWeekday(segment.Arrival)}</p>
                                                                            <p>{getCityByIata(segment.Destination)}</p>
                                                                            <p>
                                                                                {segment.Details?.[0]?.DestinationTerminal 
                                                                                    ? `Terminal: ${segment.Details[0].DestinationTerminal}`
                                                                                    : "Terminal not specified"}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <div className="rightWrap">
                                                            <ul>
                                                                <li>
                                                                    <p>Baggage</p>
                                                                    {segment.Baggage?.map((bag, i) => (
                                                                        <h3 key={i}>
                                                                            {bag.PassengerTypeCode}: {bag.Amount} {bag.Units}
                                                                        </h3>
                                                                    ))}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    {/* Layover Information */}
                                                    {segIndex < direction.Segments.length - 1 && (
                                                        <div className="ticketinfoWrap layover-info">
                                                            <ul>
                                                                <li>
                                                                    <img 
                                                                        src={LayoverImg1} 
                                                                        alt="Layover" 
                                                                        className="img-fluid" 
                                                                    />
                                                                    <p>
                                                                        Layover at {getCityByIata(segment.Destination)} ({segment.Destination}) - 
                                                                        Duration: {calculateLayoverTime(
                                                                            segment.Arrival, 
                                                                            direction.Segments[segIndex + 1].Departure
                                                                        )}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}

                                            <div className="ticketinfoWrap">
                                                <ul>
                                                    <li>
                                                        <img src={TwoTickets} alt="" className="img-fluid"/>
                                                        <p>Separate tickets booked together for cheaper price</p>
                                                    </li>
                                                    <li>
                                                        <img src={Travelator} alt="" className="img-fluid"/>
                                                        <p>Change of Terminal</p>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="btmNote">
                                                <img src={Traveler} className="img-fluid" alt="" />
                                                <p>Sorry, extra check-in baggage allowance details are not available currently from airline.</p>
                                            </div>
                                        </div>

                                        <div className="rightWraps">
                                            <div className="title">
                                                <h2>Bar Code</h2>
                                            </div>
                                            <div className="qrCode">
                                                <img src={BarcodeImg1} className="img-fluid" alt="" />
                                            </div>
                                            <div className="barCode">
                                                <img src={BarcodeImg2} className="img-fluid" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))} 
                    
                    </div>
                </div>
                <div className="termsAndConWrap">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-11">
                                <div className="dataWrap">
                                    <h2>Terms and Conditions</h2>
                                    <h6>Payments</h6>
                                    <ul>
                                        <li>If you are purchasing your ticket using a debit or credit card via the Website, we will process these payments via the automated secure common payment gateway which will be subject to fraud screening purposes. </li>
                                        <li>If you do not supply the correct card billing address and/or cardholder information, your booking will not be confirmed and the overall cost may increase. We reserve the right to cancel your booking if payment is declined for any reason or if you have supplied incorrect card information. If we become aware of, or is notified of, any fraud or illegal activity associated with the payment for the booking, the booking will be cancelled and you will be liable for all costs and expenses arising from such cancellation, without prejudice to any action that may be taken against us.</li>
                                        <li>Golobe may require the card holder to provide additional payment verification upon request by either submitting an online form or visiting the nearest Golobe office, or at the airport at the time of check-in. Golobe reserves the right to deny boarding or to collect a guarantee payment (in cash or from another credit card) if the card originally used for the purchase cannot be presented by the cardholder at check-in or when collecting the tickets, or in the case the original payment has been withheld or disputed by the card issuing bank. Credit card details are held in a secured environment and transferred through an internationally accepted system.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>      
            <Footer></Footer>
        </>
    );
}
export default FlightReservationTwo;